import { LOCALES } from 'i18n/locales';

export const activityTypeIntl = {
    [LOCALES.ENGLISH]: {
        'activityType.missing': 'Activity types are not currently available. Please try again later to set these.',
        'activityType.category': 'Activity type category',
        'activityType.category.hint': 'Type of work you are planning to carry out in the selected area',
        'activityType.value': 'Activity type value',
        'activityType.value.hint': 'Specific type of work you are planning to carry out in the selected area',
        'activityType.chooseOption': 'Choose an activity type',
        'activityType.chooseCatFirst': 'Choose a category first'
    },
    [LOCALES.WELSH]: {
        'activityType.missing': 'Nid yw mathau o weithgarwch ar gael ar hyn o bryd. Rhowch gynnig eto arni yn nes ymlaen i osod y rhain.',
        'activityType.category': 'Categori math o weithgarwch',
        'activityType.category.hint': '[Type of work you are planning to carry out in the selected area]',
        'activityType.value': 'Gwerth math gweithgarwch',
        'activityType.value.hint': '[Specific type of work you are planning to carry out in the selected area]',
        'activityType.chooseOption': 'Dewis math o weithgarwch',
        'activityType.chooseCatFirst': 'Dewiswch gategori yn gyntaf'
    }
};
